import React, { useEffect, useState, useContext } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { CustomerContext } from '../../../contexts/CustomerContext'
import Grid from '../../Grid'
import CustomerCart from '../../CustomerCart'
import styles from './OrderReview.module.sass'
import Typography from '../../Typography'
import Button from '../../Button/v2'
import { pluralize } from '../../../utils/functions'
import Spinner from '../../Spinner'
import { routes } from '../../../routes'
import useQueryString from '../../../hooks/use-query-string'
import CouponForm from './CouponForm'
import { OrderPackage, Package } from "../../../models";
import afterpayLogoWhite from '../../../assets/afterpay-green.png';

const OrderReview = () => {
  const { app } = useQueryString()
  const [text, setText] = useState('CART')
  const [lastOrderPackage, setLastOrderPackage] = useState()
  const [loading, setLoading] = useState(true)
  const { customer, setCustomer } = useContext(CustomerContext)
  const history = useHistory()

  const [isLoading, setIsLoading] = useState(true);

  // Cart payloads from the API can contain circular refs between
  // OrderPackage <-> StudentImage, so we avoid JSON.stringify(customer.cart)
  // in dep arrays. Identity + length is enough to re-trigger these effects
  // when the cart actually changes.
  const cartKeyForDeps = customer.priorityCart ? 'priorityCart' : 'cart'
  const cartIdForDeps = customer[cartKeyForDeps]?.id
  const orderPackagesLengthForDeps = customer[cartKeyForDeps]?.orderPackages?.length || 0
  const lastOrderPackageIdForDeps = customer[cartKeyForDeps]?.orderPackages?.at(-1)?.id

  useEffect(() => {
    const key = customer.priorityCart ? 'priorityCart' : 'cart'
    const lastPackageId = customer[key].orderPackages.at(-1)?.id

    if (!lastPackageId) return;

    OrderPackage.includes('package').find(lastPackageId)
      .then((data) => {
        setLastOrderPackage(data.data)
      })
  }, [cartIdForDeps, lastOrderPackageIdForDeps])

  useEffect(() => {
    const key = customer.priorityCart ? 'priorityCart' : 'cart'
    const numItems = customer[key].orderPackages.length

    if (numItems < 1) return

    setText(`CART subtotal (${pluralize('item', numItems)})`)
  }, [cartIdForDeps, orderPackagesLengthForDeps])

  useEffect(() => {
    setTimeout(() => { setLoading(false) }, 2000)
  }, [])

  const redirectRoute = () => {
    if (lastOrderPackage?.package?.name?.toLowerCase().includes('yearbook')) {
      return routes.studentIdEntry({ order: 'yearbook_order' })
    }

    return routes.studentIdEntry()
  }

  return (
    <div>
      {!loading ? (
        <div className={styles.innerContainer}>
          {text && (
            <Grid container item justify="space-between" alignItems="center" xs={12} classes={styles.padded}>
              <Grid item xs={6} classes={styles.text}>
                <Typography>Checkout</Typography>
              </Grid>
            </Grid>
          )}
          {isLoading && <div className={styles.spinnerContainer}><Spinner color="blue" /></div>}
          <Grid item xs={12}>
            <CustomerCart displayPurchaseInfo classes={styles.cart} setIsLoading={setIsLoading}>
              <CouponForm />
            </CustomerCart>
            <div style={{ 
              display: 'flex',
              justifyContent: 'center', // Changed from flex-end to center
              alignItems: 'center',
              gap: '10px',
              marginTop: '10px'
            }}>
              
              <p style={{ margin: 0, fontSize: 'calc(7px + 0.5vw)', }}>
                Available in 4 interest-free payments of ${((customer?.cart?.apiTotal )/ 4).toFixed(2)} with 
              </p>
              <img 
                style={{ 
                  width: '150px', 
                  height: 'auto'
                }} 
                src={afterpayLogoWhite} 
                alt="AfterPay Logo" 
              />
            </div>
          </Grid>
          {!isLoading && (
            <div className={styles.buttons}>
              <Link to={routes.checkout()} className={styles.link}>
                <Button type="submit">Continue to Payment</Button>
              </Link>
              {!app && (
                <Button
                  variant=""
                  classes={styles.addStudent}
                  onClick={() => {
                    setCustomer({ ...customer, currentOrderPackage: null })
                    history.push(redirectRoute())
                  }}
                >
                  + Add Another Student to Order
                </Button>
              )}
            </div>
          )}
        </div>
      ) : <div className={styles.spinnerContainer}><Spinner /></div>}
    </div>
  )
}

export default OrderReview
